export default {
  metaNav: {
    dataProtection: { name: 'Protection des données', url: 'https://www.mercedes-benz.ch/fr/passengercars/content-pool/tool-pages/legal/privacy-statement-switzerland.html' },
  },
  legalNote: 'Prix principal: utilisation gratuite d’un Mercedes-Benz EQC pendant un an, assurance, forfait d’électricité pour charger la voiture compris. EQC, 408 ch (300 kW), 21,4 kWh/100 km (équivalent-essence: 2,4 l/100 km), 0 g CO2/km, émissions de CO2 résultant de la mise à disposition du carburant et/ou du courant électrique: 30 g/km, catégorie de rendement énergétique: A.',
  navigation: {
    game: 'Le jeu',
    ranking: 'Classement',
    rankingTeam: 'Classement par équipes',
    guide: 'Survival Guide',
    rules: 'Règles du jeu',
    faq: 'FAQs',
    eqc: 'L’EQC',
    prizes: 'Prix',
    partners: 'Partenaires',
  },
  ranking: {
    rank: 'Place',
    name: 'Nom',
    nick: 'Pseudo',
    team: 'Nom de l’équipe',
    time: 'Temps de jeu',
  },
  titles: {
    default: 'Electric Quest Zurich | le jeu de réalité mixte de Mercedes-Benz',
    guide: 'Survival Guide | Electric Quest Zürich | Mercedes-Benz',
    rules: 'Règles du jeu | Electric Quest Zürich | Mercedes-Benz',
    faq: 'FAQs | Electric Quest Zürich | Mercedes-Benz',
    eqc: 'Le Mercedes-Benz EQC | Electric Quest Zurich',
    prizes: 'Prix | Electric Quest Zurich | Mercedes-Benz',
    partners: 'Partenaires | Electric Quest Zurich | Mercedes-Benz',
  },
  appstores: {
    label: 'Téléchargez maintenant sur:',
    apple: 'itms-apps://apps.apple.com/ch/app/electric-quest/id1434537643?mt=8',
    google: 'https://play.google.com/store/apps/details?id=com.staay.electricquest',
  },
  footer: {
    title: 'Nous te tenons informé.',
    newsletter: 'Abonne-toi à notre newsletter et nous t’informerons de tout ce qu’il faut savoir à propos d’Electric Quest. Si tu t’es déjà inscrit dans l’application, tu es déjà abonné à cette newsletter.',
    social: 'Suis-nous sur:',
    toTop: 'Vers le haut',
    meta: [
      {
        name: 'Protection des données Suisse',
        url: 'https://www.mercedes-benz.ch/fr/passengercars/content-pool/tool-pages/legal/privacy-statement-switzerland.html',
      },
      {
        name: 'Protection des données Liechtenstein',
        url: 'https://www.mercedes-benz.ch/fr/passengercars/content-pool/tool-pages/legal/privacy-statement-switzerland.html ',
      },
      {
        name: '© 2019 Mercedes-Benz Suisse SA',
        url: 'https://www.mercedes-benz.ch/fr/passengercars/content-pool/tool-pages/legal/copyright.html',
      },
      {
        name: 'Cookies',
        url: 'https://www.mercedes-benz.ch/fr/passengercars/content-pool/tool-pages/legal/cookies.html',
      },
      { name: 'Mentions légales',
        url: 'https://www.mercedes-benz.ch/fr/passengercars/content-pool/tool-pages/legal/legal-notice.html',
      },
      { name: 'Conditions de participation',
        route: '/fr/terms',
      },
    ],
  },
  banners: {
    cookies: {
      title: 'Utilisation des cookies',
      body: '<p>Nous utilisons des cookies ainsi que des technologies de tracking et de (re)ciblage.<p><p>Nous voulons ainsi concevoir nos pages web de manière conviviale et les améliorer en continu tout en affichant les offres et les contenus publicitaires qui te correspondent. En continuant à utiliser cette page web, tu acceptes l’utilisation de cookies.</p><p>De plus amples informations et des options supplémentaires figurent dans nos <a href="https://www.mercedes-benz.ch/fr/passengercars/content-pool/tool-pages/legal/cookies.html" target="_blank">informations relatives à la protection des données et aux cookies</a>.</p>',
    },
  },
  labels: {
    confirm: 'OK',
    newsletter: {
      title: [
        { value: 'mr', name: 'Monsieur' },
        { value: 'mrs', name: 'Madame' },
      ],
      firstname: 'Prénom',
      lastname: 'Nom',
      email: 'Adresse e-mail',
      terms: 'J’accepte les <a href="#" data-overlay="terms">dispositions relatives à la protection des données</a>.',
      registernow: 'S’inscrire maintenant',
      send: 'Envoyer le formulaire',
      pending: 'Merci! Nous venons de t’envoyer un e-mail de confirmation.',
      error: 'Complète s’il te plaît tous les champs sans oublier de nous fournir une adresse e-mail valable.',
    },
  },
};
